export type AuthorizeCreatorSubscriptionSpotifyResponse = {
  deepLinkURI: string;
};

async function authorizeCreatorSubscriptionSpotify({
  webStationId,
  userId,
}: {
  webStationId: string;
  userId: number;
}): Promise<AuthorizeCreatorSubscriptionSpotifyResponse> {
  const response = await fetch(
    `/api/proxy/v3/podcastSubscriptions/spotify/register`,
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        webStationId,
        userId,
      }),
    }
  );
  if (response.ok) {
    return response.json();
  }
  throw new Error('Unable to register Spotify Subscription');
}

export { authorizeCreatorSubscriptionSpotify };
